import React, { useRef, useState } from 'react';
import styles from './style.module.scss';
import Heading from '../heading/Heading';
import classNames from 'classnames';
import { CaretIcon, OptionIcon, waveImage } from 'assets';
import { useSelector } from 'react-redux';
import DropDownOptions from '../dropdown/dropdown_option/DropdownOption';
import { optionsDateRange } from 'shared/utils/IntegrationConstant';
import { dateRangesEnum } from 'shared/utils/Enum';
import { startOfDay, endOfDay, subDays, startOfWeek, subMonths, startOfMonth, subQuarters, startOfQuarter, subYears, startOfYear } from 'date-fns';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
const option = [{ title: 'All Time' }, { title: 'Last Week' }, { title: 'Last Month' }];
export default function DashboardSummary({ SummaryContainerStyle, isEdit = false, count, title, variant, path }) {
    const dropdownRef = useRef(null);
    const navigate = useNavigate();
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const [dateRange, setDateRange] = useState('Today');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [openSelection, setOpenSelection] = useState(false);
    const [openModalCustomDate, setOpenModalCustomDate] = useState(false);
    const handleDateRangeChange = (start, end) => {
        setStartDate(start);
        setEndDate(end);
    };

    return (
        <div
            className={classNames(`${theme}SummaryContainer`, styles.SummaryContainer, styles[variant], SummaryContainerStyle ? SummaryContainerStyle : '')}
            onClick={() => path && navigate(path)}
            style={{ cursor: path ? 'pointer' : 'default' }}
        >
            <div className={classNames(styles.SummaryInfo)}>
                <Heading heading={count} headingStyle={styles.SummaryHeading} />
                <p className={classNames(styles.SummaryDesc, `${theme}FontBlackOne`)}>{title}</p>
            </div>
            <div
                className={classNames(styles.SummaryFilterContainer)}
                ref={dropdownRef}
                onClick={(e) => {
                    e.stopPropagation();
                    setOpenSelection(!openSelection);
                }}
            >
                {/* <div className={classNames(styles.SummaryFilter)}>
                    <span className={classNames('me-1', styles.FilterText, `${theme}FontBlackTwo`)}>
                        {' '}
                        {dateRange === dateRangesEnum.customDateRange ? `${moment(startDate).format('M/D/YY')} - ${moment(endDate).format('M/D/YY')}` : dateRange}
                    </span>
                    <CaretIcon className={classNames(styles.FilterIcon, `${theme}SvgIcon`)} />
                </div> */}
                <img src={waveImage} className={classNames(styles.SummaryImage)} alt="summary not found" />
            </div>
            <DropDownOptions
                options={optionsDateRange}
                openSelection={openSelection}
                setOpenSelection={setOpenSelection}
                customContainer={styles.OptionContainer}
                ref={dropdownRef}
            />
        </div>
    );
}
